<template>
<div>

       <ul v-if="item && item.contents.length" class="contents">
          <li v-for="(content,key) in item.contents" :key="key">
              <div v-if="item.contents[key]">
                  <label>  # {{item.contents[key].id}}</label>
                  <sub-field-list v-if="item.contents[key].fields.length" 
                        :name="`cont-${key}`" 
                        :subFields="item.contents[key].fields" 
                        v-model="item.contents[key]" />
              </div>
          </li>
       </ul>
      <div class="save-panel">
          <button class="btn btn-sm btn-warning btn-icon" @click="updateItem">
               <span class="ti-save"></span>Сохранить
          </button>
              <button @click="push" class="btn btn-sm btn-danger ml-3">+ HTML</button>  
    </div>
  </div>
</template>
<script>

import { cardUpdate, cardContent } from "@/plugins/functions";

export default {
  props: ["id"],
  components:{
    'sub-field-list ': () => import('@/components/Item/SubFieldList')
  },
  data: () => ({
    item:null,
    cardLink:'posts',
  }),
   async created(){
     await this.getItems();
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async getItems(){
      this.item = null;
      this.item = await this.cardContent(this.cardLink, this.id);
    },
     updateItem() {4
      this.$loading(true);
      this.$http({ url: `${this.cardLink}/${this.id}`,
          method: 'PUT',
          data: {contents:this.item.contents, is_content:true}})
          .then(response => {

              this.item.contents = [];

              setTimeout(() => {
                      this.item.contents = response.data.data.contents;          
              }, 100);
    
          }).finally(()=>{
            this.$loading(false);
          });
    },
    push(){
      this.item.contents.push({
            value: '',
            id:null,
            type:'html',
            translations:[
               { value: "", locale: "ru" },
               { value: "", locale: "uz" },
            ],
            fields:[
              {
                    col:' col-12 col-md-12',
                    key: "is_remove",
                    label: "Удалить?",
                    type: "checkbox",
              },
              {
                    col:' col-12 col-md-12',
                    key: "value",
                    label: "Описание",
                    type: "html",
                    isMultiLang:true
              }
            ]
      });
    }
  },
};
</script>
<style lang="scss">
  ul.contents {
      margin-top:50px;
      & > li {
          display:block;
          margin-bottom:30px;
      }
  }
</style>
